import React, { Fragment, useState } from "react"
import { Modal } from "react-bootstrap"
import { FaLink } from "react-icons/fa"
import { FaUnlink } from "react-icons/fa"

import classes from "./EditorAddLink.module.scss"

const EditorAddLink = (props) => {
  const { editor } = props

  const [showModal, setShowModal] = useState(false)

  const addLink = () => {
    const url = window.prompt("Enter URL:")

    if (url) {
      editor
        .chain()
        .focus()
        .setLink({ href: url })
        .run()
    }
  }

  return (
    <Fragment>
      <div className={classes["container"]}>
        <button
          onClick={addLink}
          className={classes["button"]}
        >
          <FaLink />
        </button>
        <button
          onClick={() => editor.chain().focus().extendMarkRange("link").unsetLink().run()}
          className={classes["button"]}
        >
          <FaUnlink />
        </button>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdrop="static"
        centered
      >

      </Modal>
    </Fragment>
  )
}

export default EditorAddLink